import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './ToolEstateUser.css';
import { Dialog, Snackbar, AppBar, Toolbar } from '@material-ui/core';
import { BASE_URL } from '../../store/config';
import simpleHttp from '../../request/simpleHttp';
import { roleStr, globalData, defaultPageSize, ADD, EDIT, CLIENT, SPOUSE } from '../../common/common';
import EstateInfo from './components/normal/EstateInfo';
import EstateInfoSingle from './components/single/EstateInfo';
import Alert from '@material-ui/lab/Alert';
import { getUrlParams } from '../../common/utils';

class ToolEstateUser extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isMarried: true,
            dialogTitle: "EDIT DOCUMENT",
            dialogState: EDIT,
            dialogData: null,
            dialogTitleSingle: "EDIT DOCUMENT",
            dialogStateSingle: EDIT,
            dialogDataSingle: null,

            showToast: false,
            toastMsg: "",
            toastState: "success",
            toastTitle: "",
            showAlert: false,
            showReplace: false,
            showAlertDownload: false,
            showAlertFile: false,
            dialogContent: "",
            toastTime: 3000,
            validCode: false,
            code: "",
            firstName: "",
            errText: "",
            isSubmit: false,
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleCreateSingle = this.handleCreateSingle.bind(this);
    }
    render() {
        const {
            isMarried,
            dialogTitle,
            dialogState,
            dialogData,
            dialogTitleSingle,
            dialogStateSingle,
            dialogDataSingle,
            showToast,
            toastTitle,
            toastState,
            toastTime,
            validCode,
            code,
            firstName,
            errText,
            isSubmit,
        } = this.state;


        console.log('submit', isSubmit);
        const contentView = () => {
            if (validCode) {
                if (isMarried) {
                    return <div className="content c">
                        <EstateInfo
                            title={dialogTitle}
                            data={dialogData}
                            state={dialogState}
                            firstName={firstName}
                            handleCreate={this.handleCreate}
                        ></EstateInfo>
                    </div>
                } else {
                    return <div className="content c">
                        <EstateInfoSingle
                            title={dialogTitleSingle}
                            data={dialogDataSingle}
                            state={dialogStateSingle}
                            handleCreate={this.handleCreateSingle}
                        ></EstateInfoSingle>
                    </div>
                }
            } else if (isSubmit) {
                return <div className="content-text c">
                    <div className="hint-text">Thank you for your time! This questionnaire has been submitted successfully.</div>
                </div>
            } else {
                return <div className="content-text c">
                    <div className="hint-text">{errText}</div>
                </div>
            }
        }
        return (
            <Root>
                <AppBar position="absolute" color="default">
                    <Toolbar>
                        <div className="logo"></div>
                    </Toolbar>
                </AppBar>
                {contentView()}
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={showToast} autoHideDuration={toastTime} onClose={this.handleClose}>
                    <Alert severity={toastState}>
                        {toastTitle}
                    </Alert>
                </Snackbar>
            </Root>
        );
    }
    handleClose() {
        this.setState(() => ({
            showToast: false
        }))
    };
    componentDidMount() {
        const code = getUrlParams("code");
        if (code) {
            this.setState({
                code
            }, () => {
                this.verificationCode(code, () => {
                    this.getTempEstateData(code, (data) => {
                        if (data) {
                            this.addSpouse(data.content);
                            this.setState({
                                dialogData: data
                            })
                        }
                    });
                });
            })
        }
    }
    handleCreate(obj, isCreate) {
        const { code } = this.state;
        if (isCreate) {
            this.putEstateData(code, obj.content);
        } else {
            this.putTempEstateData(code, obj.content);
        }
    }
    handleCreateSingle(obj) {
        const { dialogDataSingle, dialogStateSingle } = this.state;
        if (dialogStateSingle === ADD) {
            this.addEstate(obj, "single");
        } else if (dialogStateSingle === EDIT) {
            this.updateEstate(dialogDataSingle.id, obj, "single");
        }
    }
    addSpouse(contentObj) {
        if (Object.keys(contentObj).length === 0) return;
        const spouseObj = this.extractSpouse(contentObj["INFO"]);
        const spouseCObj = this.extractSpouseC(contentObj["INFO"]);
        // for (const key in contentObj) {
        //     if (contentObj.hasOwnProperty(key)) {
        //         const element = contentObj[key];
        //         if (this.addSpouseKey(key)) {
        //             element.splice(0, 0, spouseObj);
        //         } else if (this.addSpouseCKey(key)) {
        //             element.splice(0, 0, spouseCObj);
        //         }
        //     }
        // }
    }
    extractSpouse(infoData) {
        const spouseInfo = {};
        // spouseInfo["id"] = "2";
        spouseInfo["type"] = SPOUSE;
        spouseInfo[".CHO.Em."] = infoData["S.Em"];
        spouseInfo[".CHO.N."] = infoData["S.F.Name"];
        spouseInfo[".CHO.AddrNPho"] = infoData["S.H.Addr."];
        spouseInfo[".CHO.Addr"] = infoData["S.H.Addr."];
        spouseInfo["S.H.Pho"] = infoData["S.H.Pho"];
        spouseInfo["S.W.Pho"] = infoData["S.W.Pho"];
        spouseInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
        spouseInfo["rc"] = "Client's";
        spouseInfo["relation"] = (infoData["P.SEX"] === "male") ? "Wife" : "Husband";
        globalData.spouseInfo = spouseInfo;
        return spouseInfo;
    }
    extractSpouseC(infoData) {
        if (!infoData) return;
        const clientInfo = {};
        // clientInfo["id"] = "1";
        clientInfo["type"] = CLIENT;
        clientInfo[".CHO.Em."] = infoData["P.Em"];
        clientInfo[".CHO.N."] = infoData["P.F.Name"];
        clientInfo[".CHO.AddrNPho"] = infoData["P.H.Addr."];
        clientInfo[".CHO.Addr"] = infoData["P.H.Addr."];
        clientInfo["P.H.Pho"] = infoData["P.H.Pho"];
        clientInfo["P.W.Pho"] = infoData["P.W.Pho"];
        clientInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        clientInfo["rc"] = "Spouse's";
        clientInfo["relation"] = (infoData["P.SEX"] === "male") ? "Husband" : "Wife";
        globalData.clientInfo = clientInfo;
        return clientInfo;
    }
    addSpouseKey(key) {
        if (key === "Ex") {//3 c
            return false;
        } else if (key === "Gu") {//4
            return true;
        } else if (key === "POA") {//5
            return false;
        } else if (key === "C.W.S.P.R") {//8
            return false;
        } else if (key === "C.F.S.P.R") {//9 c
            return false;
        } else if (key === "TRUSTEE") {//19
            return false;
        } else {
            return false;
        }
    }
    addSpouseCKey(key) {
        if (key === "S.Ex") {//11 s
            return false;
        } else if (key === "S.Gu") {//12
            return true;
        } else if (key === "S.POA") {//13
            return false;
        } else if (key === "S.W.S.P.R") {//16
            return false;
        } else if (key === "S.F.S.P.R") {//17 s
            return false;
        } else {
            return false;
        }
    }
    //---------------request---------------
    verificationCode(code, callback = null) {
        simpleHttp.get(BASE_URL + `tool/eu/estate/planning/code/${code}`).then((res) => {
            console.log(res);
            this.setState({
                validCode: true,
                firstName: res.data.data.first_name
            })
            if (callback) callback();
        }).catch((err) => {
            const errCode = err.response;
            if (errCode) {
                if (errCode.data.error === 1001) {
                    this.setState({
                        validCode: false,
                        errText: 'This form has expired, please contact your lawyer'
                    })
                }
            }
        })
    }
    putEstateData(code, content) {
        const params = {
            content,
        }

        console.log('submit');
        simpleHttp.put(BASE_URL + `tool/eu/estate/planning/code/${code}`, params).then((res) => {
            this.setState(() => ({
                // toastTime: 3000,
                // showToast: true,
                // toastState: "success",
                // toastTitle: "The form data has been submitted",
                validCode: false,
                isSubmit: true
            }))
        }).catch((err) => {
            this.setState({
                validCode: false,
                errText: 'This form has expired, please contact your lawyer'
            })
        })
    }
    getTempEstateData(code, callback = null) {
        simpleHttp.get(BASE_URL + `tool/eu/estate/planning/code/${code}/temp/content`).then((res) => {
            const data = res.data.data;
            if (callback) callback(data);
        }).catch((err) => {
        })
    }
    putTempEstateData(code, content) {
        const params = {
            content,
        }
        simpleHttp.put(BASE_URL + `tool/eu/estate/planning/code/${code}/temp/content`, params).then((res) => {
            this.setState(() => ({
                toastTime: 3000,
                showToast: true,
                toastState: "success",
                toastTitle: "The form data has been saved"
            }))
        }).catch((err) => {
            this.setState({
                validCode: false,
                errText: 'This form has expired, please contact your lawyer'
            })
        })
    }
}

export default withRouter(ToolEstateUser);